import { GridColDef } from "@mui/x-data-grid";

const permissionsColumnDef: GridColDef[] = [
    { field: 'permission_name', headerName: 'Permission Name', width: 150 },
    { field: 'permission_type', headerName: 'Permission Type', width: 150 },
    { field: 'is_active', headerName: 'Permission Active Status', width: 200 },
    { field: 'created_date', headerName: 'Created Date', width: 150 },
    { field: 'created_by', headerName: 'Created By', width: 150 },
    { field: 'updated_date', headerName: 'Updated Date', width: 150 },
    { field: 'updated_by', headerName: 'Updated By', width: 150 },
];

export default permissionsColumnDef;